import Page from "components/Page";
import { lazyWithRetry } from "helpers/lazyWithRetry";

const HolidayList = lazyWithRetry(() => import("./HolidayList"));

export default () => (
  <Page>
    <HolidayList />
  </Page>
);
